import React from "react";
import { Box, Typography } from "@mui/material";
import FolderIcon from "@mui/icons-material/Folder";
import QuizIcon from "@mui/icons-material/Quiz";
import { renderTruncatedText } from "../../core/Constant";

export const DirectoryItem = ({
  name,
  isFolder,
  isLoading,
  onClick,
  truncateLimit = 40,
  folderBgColor = "#9834F0",
  iconColor = "#9834F0",
}) => {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 1.5,
        cursor: isLoading ? "wait" : isFolder ? "pointer" : "default",
        pointerEvents: isLoading ? "none" : "auto",
      }}
      onClick={isFolder ? onClick : undefined}
    >
      <Box
        sx={{
          width: 36,
          height: 36,
          borderRadius: "10px",
          bgcolor: isFolder ? folderBgColor : "#ffffff",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexShrink: 0,
        }}
      >
        {isFolder ? (
          <FolderIcon sx={{ color: "#fff", fontSize: 20 }} />
        ) : (
          <QuizIcon sx={{ color: iconColor, fontSize: 20 }} />
        )}
      </Box>
      <Typography
        sx={{
          fontWeight: 500,
          color: isFolder ? folderBgColor : "#1a1a1a",
          "&:hover": isFolder ? { textDecoration: "underline" } : {},
        }}
      >
        {renderTruncatedText(name, { limit: truncateLimit })}
      </Typography>
    </Box>
  );
};